<div class="container">
  <div class="indicator-bar" [ngStyle]="backgroundStyle"></div>
</div>
